import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-brand-gray px-6 py-16" data-id="element-109">
      <div className="max-w-2xl mx-auto" data-id="element-110">
        <div className="bg-white rounded-[16px] p-8 text-center shadow-[0_4px_24px_rgba(0,0,0,0.04)]" data-id="element-111">
          <div className="flex justify-center mb-6" data-id="element-112">
            <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center" data-id="element-113">
              <ShieldCheckIcon size={40} className="text-green-600" data-id="element-114" />
            </div>
          </div>

          <h2 className="text-[28px] font-bold text-brand-text mb-2 leading-tight" data-id="element-115">
            Garantía de Satisfacción
          </h2>

          <p className="text-green-700 text-[14px] font-bold uppercase tracking-wider mb-6" data-id="element-116">
            7 DÍAS · SIN PREGUNTAS · SIN RIESGO
          </p>

          <p className="text-[16px] text-brand-text leading-relaxed mb-4" data-id="element-117">
            Si dentro de los primeros <strong data-id="element-118">7 días</strong> sentís que el
            Método pH-ZERO no es para vos, te devolvemos el 100% de tu dinero.
          </p>

          <p className="text-[16px] text-brand-text leading-relaxed mb-8" data-id="element-119">
            Sin formularios, sin excusas, sin preguntas incómodas. Un solo
            mensaje y listo.
          </p>

          <div className="flex flex-col gap-4 max-w-md mx-auto text-left mb-8" data-id="element-120">
            <div className="flex items-start gap-3" data-id="element-121">
              <span className="text-green-600 mt-0.5" data-id="element-122">✅</span>
              <p className="text-[15px] text-brand-text leading-snug" data-id="element-123">
                <strong data-id="element-124">Reembolso completo</strong> — sin retenciones ni costos
                ocultos
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-125">
              <span className="text-green-600 mt-0.5" data-id="element-126">✅</span>
              <p className="text-[15px] text-brand-text leading-snug" data-id="element-127">
                <strong data-id="element-128">Proceso simple</strong> — escribís un mensaje y te
                devolvemos la plata
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-129">
              <span className="text-green-600 mt-0.5" data-id="element-130">✅</span>
              <p className="text-[15px] text-brand-text leading-snug" data-id="element-131">
                <strong data-id="element-132">Sin riesgo real</strong> — o funciona, o recuperás tu
                inversión
              </p>
            </div>
          </div>

          <p className="text-[16px] text-brand-text font-bold" data-id="element-133">
            Tu confianza es nuestra prioridad. Creemos tanto en este método que
            asumimos todo el riesgo por vos.
          </p>
        </div>
      </div>
    </section>;
}